<template>
  <component
    :is="itemComponent"
    ref="triggerItem"
    :data="data"
    :value="data.fieldvalue"
    :placeholder="placeholder"
    @change="handleChange"
  />
</template>

<script>
import MyInput from '@/pc/inquery/formItem/Input'
import MySelect from '@/pc/inquery/formItem/Select'
import SelectTree from '@/pc/inquery/filterItem/SelectTree'
import MyArea from '@/pc/inquery/filterItem/Area'
import DateTime from '@/pc/inquery/formItem/DateTime'
import DateGroup from '@/pc/inquery/filterItem/DateGroup'
import InputGroup from '@/pc/inquery/filterItem/InputGroup'

export default {
  props: {
    data: {
      type: [Object, Array, String, Boolean],
      default: () => { }
    },
    typevalue: {
      type: String,
      default: ''
    }
  },

  data () {
    return {
      itemComponent: ''
    }
  },

  computed: {
    inquiryId () {
      return this.$route.params.inquiryId
    },
    from () {
      return this.$route.query.from || 'all'
    },
    type () {
      return this.$route.query.type
    },
    placeholder () {
      if (!this.data) return

      const { fieldname = '', fieldtype = '', fieldconfig = {} } = this.data || {}
      const { placeholder = '' } = fieldconfig

      if (fieldtype === 'text' || fieldtype === 'ip' || fieldtype === 'number' || fieldtype === 'editor' || fieldtype === 'tag') {
        return placeholder || '请输入' + fieldname
      } else if (fieldtype === 'phone' || fieldtype === 'email') {
        return placeholder || '请输入' + fieldname + ',多个时可用逗号隔开'
      } else {
        return placeholder || '请选择' + fieldname
      }
    }
  },

  watch: {
    data: {
      handler (val) {
        this.setItem()
      },
      deep: true,
      immediate: true
    },
    typevalue (val) {
      this.setItem()
    }
  },

  methods: {
    setItem () {
      if (!this.data) return

      let { fieldtype, fieldvalue = '' } = this.data || {}
      let value = fieldvalue

      switch (fieldtype) {
        case 'text':
          this.itemComponent = MyInput
          break
        case 'number':
          if (this.typevalue === '～') {
            this.itemComponent = InputGroup

            if (this.$toType(fieldvalue) === 'array') {
              value = {} // min max
              value.min = fieldvalue[0]
              value.max = fieldvalue[1]
            } else {
              value = fieldvalue
            }
          } else {
            this.itemComponent = MyInput
            value = this.$toType(fieldvalue) !== 'string' || !fieldvalue ? '' : fieldvalue
          }
          break
        case 'phone':
        case 'email':
          this.itemComponent = MyInput
          value = fieldvalue || []
          break
        case 'select':
        case 'radio':
        case 'radioinfo_payfor':
        case 'radioinfo_level':
        case 'radioinfo_type':
        case 'radioinfo_followup':
        case 'checkbox':
        case 'from':
          this.itemComponent = MySelect
          if (fieldtype === 'checkbox') {
            this.$set(this.data, 'multiple', 'multiple')
            value = fieldvalue || []
          } else if (fieldtype === 'from') {
            if (this.$toType(fieldvalue) === 'object') {
              value = Object.keys(fieldvalue) && Object.keys(fieldvalue)[0]
            } else if (this.$toType(fieldvalue) === 'string') {
              value = fieldvalue ? parseInt(fieldvalue) : undefined
            }
          } else {
            value = fieldvalue ? parseInt(fieldvalue) : undefined
            this.$set(this.data, 'multiple', '')
          }
          break
        case 'select_tree':
          this.itemComponent = SelectTree
          this.data.fieldconfig.enableinput = 0
          value = fieldvalue || []
          break
        case 'datetime':
          if (this.typevalue === '～') {
            this.itemComponent = DateGroup
            if (this.$toType(fieldvalue) === 'array') {
              value = {}
              value.starttime = fieldvalue[0]
              value.endtime = fieldvalue[1]
            } else {
              value = fieldvalue
            }
          } else {
            this.itemComponent = DateTime
            this.data.fieldconfig.formatdatetime = 1
            value = !fieldvalue ? null : fieldvalue
          }
          break
        case 'area':
          this.itemComponent = MyArea
          this.data.fieldconfig.enableinput = 0
          this.data.fieldconfig.showSearch = 0
          value = fieldvalue || Object.assign({})
          break
      }
      this.$set(this.data, 'isneeded', 0)
      this.$set(this.data, 'fieldvalue', value)

      if (this.$refs.triggerItem && this.$toType(this.$refs.triggerItem.init) === 'function') {
        this.$refs.triggerItem.init()
      }

      this.$forceUpdate()
    },

    handleChange (val) {
      let { fieldtype, fieldvalue, options = [] } = this.data || {}
      if (fieldtype === 'select_tree') {
        fieldvalue = Object.keys(val)
        this.data.fieldvalue = fieldvalue
      } else if (fieldtype === 'from') {
        let curr = options.find(item => item.id === val)
        fieldvalue = {
          [curr.id]: curr.value
        }
      } else {
        fieldvalue = val
        this.data.fieldvalue = fieldvalue
      }
      this.$emit('change', fieldvalue)
      this.$forceUpdate()
    }
  }
}
</script>
